<ng-container *ngIf="loginStatus$|async as loginStatus">
  <div class="login-wrapper" fxFlexFill fxLayout="row" fxLayoutAlign="center">
    <div class="login-container" fxFlex="30" fxFlex.lt-md="100" fxLayout="column">
      <div class="login-box"  fxFlex fxLayout="row" fxLayoutAlign=" center">
        <form class="login-form-container-modal" fxFlex="" (ngSubmit)="login()" [formGroup]="loginForm" fxLayout="column" fxLayoutGap="1em"  fxFlexAlign="center" fxLayoutAlign="center center">
          <h1>{{ 'LOGIN.SYSTEM_LOGIN' | translate }}</h1>
          <div class="input-container" >
            <span class="p-inputgroup-addon"><fa-icon [icon]="faUser"></fa-icon></span>
            <input  type="email" autocomplete="email" id="email" formControlName="email" fxFlex pInputText [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate" required>
          </div>
          <div class="input-container">
            <span class="p-inputgroup-addon"><fa-icon [icon]="faLock"></fa-icon></span>
            <input  type="password" formControlName="password" fxFlex pInputText [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate" required>
          </div>
          <div class="input-container">
            <re-captcha (resolved)="resolved($event)"
                        formControlName="recaptchaReactive"
                        siteKey="6LetEkAkAAAAALbtU3IKQ8G3LSC4opEqMLgSDa71">
            </re-captcha>
          </div>
          <div class="login-button" style="width: 100%">
            <button [disabled]="!loginForm.valid" mat-raised-button color="primary" style="width: 100%" fxLayout="row" fxLayoutAlign="center">
              <span>{{ 'LOGIN.LOGIN_BUTTON' | translate }}</span>
            </button>
          </div>
          <a *ngIf="!dialogRef" class="forget" routerLink="/auth/forget">
            {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
          </a>
          <div *ngIf="dialogRef" class="reset-button" style="width: 100%">
            <button (click)="resetPassword()" mat-raised-button color="accent" style="width: 100%" fxLayout="row" fxLayoutAlign="center">
              <span>{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</span>
            </button>
          </div>
          <a *ngIf="!dialogRef" class="forget" routerLink="/auth/register">
            {{ 'LOGIN.NOT_REGISTERED' | translate }}
          </a>
          <div *ngIf="dialogRef" class="register-button" style="width: 100%">
            <button (click)="register()" mat-raised-button color="accent" style="width: 100%" fxLayout="row" fxLayoutAlign="center">
              <span>{{ 'LOGIN.NOT_REGISTERED' | translate }}</span>
            </button>
          </div>
          <div class="error-container" *ngIf="loginStatus.error&&loginStatus.error.code!==100" fxLayout="column">
            <span>{{loginStatus.error.message}}</span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ngx-ui-loader loaderId="loginLoader" [text]="'LOGIN.CONNECTING' | translate"></ngx-ui-loader>
</ng-container>

<div class="beamerTrigger"  style="color:white;visibility: hidden;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i style="font-size: 16px;"
                                                                                                           class="fa fa-bullhorn" aria-hidden="true"></i></div>
